import React, {useEffect, useState} from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { renderIcon } from "../../../constants/icons/CurrencySymbol";
import { getSalaryWitComma } from "../../../utils/helpers";
import { currencyList } from "../../../constants/helpers";

const LeftPanel = () => {
  const jobTitle = useSelector((state:RootState) => state.campaign.jobTitle);
  const companyName = useSelector((state:RootState) => state.campaign.companyName);
  const minExperience = useSelector((state:RootState) => state.campaign.minExperience);
  const maxExperience = useSelector((state:RootState) => state.campaign.maxExperience);
  const minSalary = useSelector((state:RootState) => state.campaign.minSalary);
  const maxSalary = useSelector((state:RootState) => state.campaign.maxSalary);
  const locationList = useSelector((state:RootState) => state.campaign.jobLocation);
  const currency = useSelector((state: RootState) => state.campaign.currency);
  const [currencyType,setCurrencyType] = useState<any>('')
  const corpLogo = useSelector((state: RootState) => state?.campaign.mediaList.logo);

const renderCurrencyContent = () => {
  if (currency === 'MYR' || currency === 'PHP') {
    const icon = renderIcon(currencyType);
    
    if (icon) {
      return icon;
    } else {
      return (
        <span 
          style={{
            fontSize: '11px',
            fontWeight: '500',
            color: '#A5A3AE'
          }}
        >
          {currencyType}
        </span>
      );
    }
  }else{
    return (
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.592 3.83333H11.5833L12 2.5H4.41667L4 3.83333H6.66667C7.69133 3.83333 8.552 4.498 8.866 5.41667H4.41667L4 6.75H8.91733C8.65733 7.75467 7.75267 8.5 6.66667 8.5H4V9.524L8.91667 14.5H10.6667V14.3333L6 9.66667C6.40933 9.66667 6.89533 9.66667 7 9.66667C8.73333 9.66667 10.162 8.404 10.4413 6.75H11.5833L12 5.41667H10.4147C10.2833 4.814 9.99 4.276 9.592 3.83333Z"
          fill="#A5A3AE"
        />
      </svg>
    );
  }
};

useEffect(()=>{
  if(currency){
    const selectedCurrency = currencyList.find((currency:any)=>currency.value === currency)
    const placeholder = selectedCurrency?.label
    setCurrencyType(placeholder)
  }
  },[currency])

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <div style={{ display: "flex" }}>
        <Box
          sx={{
            padding: "12px",
            width:'337px',
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            borderRadius: "20px",
            backgroundColor: "#FCFAFE",
            border: "1px solid #6E00BE",
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
            gap: "12px",
          }}
        >
          <Grid
            xs={12}
            md={12}
            lg={12}
            sx={{ display: "flex", flexDirection: "column", gap: "8px" }}
          >
            {/* job info */}
            <Grid
              xs={12}
              md={12}
              lg={12}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <Grid xs={12} md={12} lg={12} sx={{ display: "flex", borderBottom: 1, borderColor: '#F4F4F5', paddingBottom: '12px' }}>
                <Grid
                  xs={12}
                  md={10}
                  lg={10}
                  sx={{ display: "flex", gap: "4px" }}
                >
                  {corpLogo ? <img src={corpLogo} alt={companyName} style={{width:'50px', height:'50px', borderRadius:'4px'}} /> : null }
                  <Grid
                    xs={12}
                    md={12}
                    lg={12}
                    sx={{ display: "flex", flexDirection: "column", maxWidth: "100%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 600,
                        // display: "flex",
                        // alignItems: "center",
                      }}
                    >
                      {jobTitle}
                    </Typography>
                    {companyName &&  (
                      <Box sx={{ display: "flex", alignItems: 'center' }}>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#6E00BE",
                          }}
                        >
                          {companyName}
                        </Typography>
                        <svg
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.9987 1.83594C4.3247 1.83594 1.33203 4.8286 1.33203 8.5026C1.33203 12.1766 4.3247 15.1693 7.9987 15.1693C11.6727 15.1693 14.6654 12.1766 14.6654 8.5026C14.6654 4.8286 11.6727 1.83594 7.9987 1.83594ZM7.9987 3.16927C10.9521 3.16927 13.332 5.54919 13.332 8.5026C13.332 11.456 10.9521 13.8359 7.9987 13.8359C5.04528 13.8359 2.66536 11.456 2.66536 8.5026C2.66536 5.54919 5.04528 3.16927 7.9987 3.16927ZM6.89453 5.83594L8.30859 7.25L5.38411 10.1745L6.32682 11.1172L9.2513 8.19271L10.6654 9.60677V5.83594H6.89453Z"
                            fill="#6E00BE"
                          />
                        </svg>
                      </Box>
                    ) 
                    }
                  </Grid>
                </Grid>

                <Grid
                  xs={12}
                  md={2}
                  lg={2}
                  sx={{ display: "flex", gap: '12px', flex: "0 0 auto",justifyContent:'flex-end' }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.00781 1.33594C3.27751 1.33594 2.67448 1.93767 2.67448 2.66797L2.66797 14.6693L8.0013 12.6693L13.3346 14.6693V13.707V2.66927C13.3346 1.94056 12.73 1.33594 12.0013 1.33594H4.00781ZM4.00781 2.66927H12.0013V12.7448L8.0013 11.2448L4.0026 12.7448L4.00781 2.66927Z"
                      fill="#777585"
                    />
                  </svg>
                </Grid>
              </Grid>
              <Grid xs={12} md={12} lg={12} sx={{ display: "flex", borderBottom: 1, borderColor: '#F4F4F5', paddingTop: '12px', paddingBottom: '12px' }}>
                <Grid
                  xs={12}
                  md={10}
                  lg={10}
                  sx={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <Grid
                    xs={12}
                    md={12}
                    lg={12}
                    sx={{ display: "flex", gap: "9px",alignItems:'center' }}
                  >
                    <svg
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.66536 1.83594C3.93003 1.83594 3.33203 2.43394 3.33203 3.16927V5.1849C3.72136 4.8909 4.16936 4.67098 4.66536 4.57031V3.16927H9.33203V6.5026H12.6654V13.8359H10.6654V15.1693H12.6654C13.4007 15.1693 13.9987 14.5713 13.9987 13.8359V5.83594L9.9987 1.83594H4.66536ZM5.33203 5.83594C4.23536 5.83594 3.33203 6.73926 3.33203 7.83594C3.33203 8.93261 4.23536 9.83594 5.33203 9.83594C6.4287 9.83594 7.33203 8.93261 7.33203 7.83594C7.33203 6.73926 6.4287 5.83594 5.33203 5.83594ZM5.33203 7.16927C5.70812 7.16927 5.9987 7.45985 5.9987 7.83594C5.9987 8.21202 5.70812 8.5026 5.33203 8.5026C4.95595 8.5026 4.66536 8.21202 4.66536 7.83594C4.66536 7.45985 4.95595 7.16927 5.33203 7.16927ZM5.33203 11.1693C4.34773 11.1693 3.44217 11.3243 2.71875 11.6354C2.35704 11.791 2.03681 11.9858 1.77995 12.2565C1.52308 12.5272 1.33203 12.9031 1.33203 13.3138V15.1693H9.33203V14.5026V13.3138C9.33203 12.9031 9.14098 12.5272 8.88411 12.2565C8.62725 11.9858 8.30702 11.791 7.94531 11.6354C7.22189 11.3243 6.31633 11.1693 5.33203 11.1693ZM5.33203 12.5026C6.1684 12.5026 6.92989 12.6508 7.41797 12.8607C7.66201 12.9656 7.83301 13.0863 7.91667 13.1745C8.00032 13.2626 7.9987 13.2885 7.9987 13.3138V13.8359H2.66536V13.3138C2.66536 13.2885 2.66374 13.2626 2.7474 13.1745C2.83105 13.0863 3.00206 12.9656 3.24609 12.8607C3.73417 12.6508 4.49566 12.5026 5.33203 12.5026Z"
                        fill="#A5A3AE"
                      />
                    </svg>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#1D1934",
                      }}
                    >
                      Permanent Job, fulltime
                    </Typography>
                  </Grid>
                  {locationList?.length > 0 && (
                    <Grid
                      xs={12}
                      md={12}
                      lg={12}
                      sx={{ display: "flex", gap: "9px",alignItems:'center' }}
                    >
                      <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.0013 1.84375C5.43064 1.84375 3.33984 3.93584 3.33984 6.50651C3.33984 9.49518 7.31765 14.35 7.48698 14.5547L8.0013 15.1784L8.51562 14.5547C8.68496 14.3494 12.6628 9.49518 12.6628 6.50651C12.6628 3.93518 10.572 1.84375 8.0013 1.84375ZM8.0013 3.17708C9.83664 3.17708 11.3294 4.67118 11.3294 6.50651C11.3294 8.30984 9.2533 11.4114 8.0013 13.0547C6.7493 11.4127 4.67318 8.31251 4.67318 6.50651C4.67318 4.67118 6.16597 3.17708 8.0013 3.17708ZM8.0013 4.83724C7.08064 4.83724 6.33464 5.58324 6.33464 6.50391C6.33464 7.42457 7.08064 8.17057 8.0013 8.17057C8.92197 8.17057 9.66797 7.42457 9.66797 6.50391C9.66797 5.58324 8.92197 4.83724 8.0013 4.83724Z"
                          fill="#A5A3AE"
                        />
                      </svg>

                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: "#1D1934",
                        }}
                      >
                        {locationList && locationList.length > 0
                          ? locationList.map(
                              (location: any) => location
                            )
                            .join(", ")
                          : ""}
                      </Typography>
                    </Grid>
                  )}
                  <Grid
                    xs={12}
                    md={12}
                    lg={12}
                    sx={{ display: "flex", gap: "9px",alignItems:'center' }}
                  >
                    <svg
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.9987 2.5V3.16667H2.66536C1.9287 3.16667 1.33203 3.76333 1.33203 4.5V12.5C1.33203 13.2353 1.93003 13.8333 2.66536 13.8333H13.332C14.0674 13.8333 14.6654 13.2353 14.6654 12.5V4.5C14.6654 3.76333 14.0687 3.16667 13.332 3.16667H9.9987V2.5H5.9987ZM2.66536 4.5H13.332V9.16667H11.9987C11.9987 8.98986 11.9285 8.82029 11.8034 8.69526C11.6784 8.57024 11.5088 8.5 11.332 8.5C11.1552 8.5 10.9857 8.57024 10.8606 8.69526C10.7356 8.82029 10.6654 8.98986 10.6654 9.16667H5.33203C5.33203 8.98986 5.26179 8.82029 5.13677 8.69526C5.01174 8.57024 4.84218 8.5 4.66536 8.5C4.48855 8.5 4.31898 8.57024 4.19396 8.69526C4.06894 8.82029 3.9987 8.98986 3.9987 9.16667H2.66536V4.5ZM2.66536 10.5H13.332V12.5H2.66536V10.5Z"
                        fill="#A5A3AE"
                      />
                    </svg>

                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#1D1934",
                      }}
                    >
                      {`${minExperience} - ${maxExperience} Years`}
                    </Typography>
                  </Grid>
                  {(
                    <Grid
                      xs={12}
                      md={12}
                      lg={12}
                      sx={{ display: "flex", gap: "9px",alignItems:'center' }}
                    >
                     {renderCurrencyContent()} 
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: "#1D1934",
                        }}
                      >
                      <span>{`${currency === 'INR' ? (minSalary ? getSalaryWitComma(minSalary):"" ) : (minSalary || "")} - ${currency === 'INR' ? (maxSalary ? getSalaryWitComma(maxSalary) : "" ) : (maxSalary || "")} ${currency}`} </span> 

                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} md={12} lg={12} sx={{ display: "flex", }}>
              <Grid xs={12} md={6} lg={6} sx={{ display: "flex", gap: "4px", alignItems: 'center' }}>

                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.833496 8.0026C0.833496 4.04456 4.04212 0.835938 8.00016 0.835938C11.9582 0.835938 15.1668 4.04456 15.1668 8.0026C15.1668 11.9606 11.9582 15.1693 8.00016 15.1693C4.04212 15.1693 0.833496 11.9606 0.833496 8.0026ZM8.00016 3.5026C8.2763 3.5026 8.50016 3.72646 8.50016 4.0026V7.69359L10.8904 8.88872C11.1374 9.01222 11.2375 9.31255 11.114 9.55954C10.9905 9.80653 10.6902 9.90664 10.4432 9.78315L7.77656 8.44982C7.60716 8.36512 7.50016 8.19199 7.50016 8.0026V4.0026C7.50016 3.72646 7.72402 3.5026 8.00016 3.5026Z" fill="#D2D1D6" />
                </svg>


                <Typography sx={{ fontSize: "12px", fontWeight: 400 }}>
                  0 hours ago
                </Typography>
              </Grid>
              <Grid
                xs={12}
                md={6}
                lg={6}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  startIcon={
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M13.7905 3.97352L6.15739 7.31382L9.28505 8.1788C9.56685 8.25673 9.7872 8.47665 9.86568 8.7583L10.7933 12.0875L13.7905 3.97352ZM13.7485 2.90034C14.4217 2.60577 15.1189 3.26326 14.8643 3.95253L11.5528 12.9174C11.2727 13.6757 10.1853 13.6311 9.96835 12.8523L8.92767 9.1175L5.43839 8.15252C4.6822 7.94339 4.60767 6.90044 5.32643 6.5859L13.7485 2.90034ZM8.90237 9.02672L8.90246 9.02704L8.90237 9.02672ZM2.83333 4.04436C2.83333 3.76822 3.05719 3.54436 3.33333 3.54436H6.66667C6.94281 3.54436 7.16667 3.76822 7.16667 4.04436C7.16667 4.3205 6.94281 4.54436 6.66667 4.54436H3.33333C3.05719 4.54436 2.83333 4.3205 2.83333 4.04436ZM1.5 8.37769C1.5 8.10155 1.72386 7.87769 2 7.87769H3.66667C3.94281 7.87769 4.16667 8.10155 4.16667 8.37769C4.16667 8.65384 3.94281 8.87769 3.66667 8.87769H2C1.72386 8.87769 1.5 8.65384 1.5 8.37769ZM2.5 12.0444C2.5 11.7682 2.72386 11.5444 3 11.5444H6.66667C6.94281 11.5444 7.16667 11.7682 7.16667 12.0444C7.16667 12.3205 6.94281 12.5444 6.66667 12.5444H3C2.72386 12.5444 2.5 12.3205 2.5 12.0444Z"
                        fill="#2BA682"
                      />
                    </svg>
                  }
                  sx={{
                    fontSize: "12px",
                    fontWeight: 400,
                    backgroundColor: "#EAF6F2",
                    color: "#2BA682",
                    whiteSpace: "nowrap",
                    padding: "2px 8px",
                    borderRadius: "30px",
                    cursor: "default",
                    ":hover": {
                      backgroundColor: "#EAF6F2",
                      color: "#2BA682",
                    },
                  }}
                  id="quickApply"
                  aria-label="Quick Apply"
                >
                  Quick apply
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ marginTop: "2rem" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="24"
            viewBox="0 0 12 24"
            fill="none"
          >
            <path
              d="M12 12.3333L-1.08755e-06 23.8803L-7.80829e-08 0.786328L12 12.3333Z"
              fill="#6E00BE"
            />
          </svg>
        </Box>
      </div>

      <Box
        sx={{
          height: "208px",
          padding: "12px",
          width: '337px',
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          borderRadius: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
        }}
      >
        {/* Content for Box 2 */}
        <Typography
          sx={{
            color: "#A5A3AE",
            fontSize: "16px",
            fontWeight: 500,
          }}
        >
          Other Jobs
        </Typography>
      </Box>

      <Box
        sx={{
          height: "208px",
          padding: "12px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          borderRadius: "20px",
          width: '337px',
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
        }}
      >
        <Typography
          sx={{ color: "#A5A3AE", fontSize: "16px", fontWeight: 500 }}
        >
          Other Jobs
        </Typography>
      </Box>
    </div>
  );
};

export default LeftPanel;
